module.exports = __webpack_public_path__ + "static/media/APP_OfficeChamp_152x174_6.27f6fb9b.png";